import React from "react";
import { Tabs, Input, Button, Typography, Radio } from "antd";

const { Title, Paragraph } = Typography;

const AccountSettings = () => (
  <div style={{ padding: 24, background: '#fff' }}>
    <Title level={4}>Account Information</Title>
    <Paragraph>Manage your account details and password</Paragraph>
    <div style={{ maxWidth: 400 }}>
      <label>Username</label>
      <Input defaultValue="User" disabled style={{ marginBottom: 16 }} />

      <label>Email</label>
      <Input placeholder="Enter your email" style={{ marginBottom: 16 }} />

      <Button type="primary">Save Changes</Button>
    </div>
  </div>
);

const AppearanceSettings = () => (
  <div style={{ padding: 24, background: '#fff' }}>
    <Title level={4}>Appearance</Title>
    <Paragraph>Customize the appearance of the application</Paragraph>
    <div style={{ marginTop: 16 }}>
      <label>Theme</label>
      <div style={{ marginTop: 8 }}>
        <Radio.Group defaultValue="light">
          <Radio.Button value="light">Light</Radio.Button>
          <Radio.Button value="dark">Dark</Radio.Button>
          <Radio.Button value="system">System</Radio.Button>
        </Radio.Group>
      </div>
    </div>
  </div>
);

const Settings = () => {
  return (
    <div style={{ padding: 24, background: '#f0f2f5', minHeight: '100%' }}>
      <Tabs
        defaultActiveKey="account"
        items={[
          { key: 'account', label: 'Account', children: <AccountSettings /> },
          { key: 'appearance', label: 'Appearance', children: <AppearanceSettings /> },
        ]}
      />
    </div>
  );
};

export default Settings;
